import { AppVariantConfig } from '@/types/app-config';

export const marketplacesVariant: AppVariantConfig = {
  id: 'marketplaces',
  name: 'Marketplaces',
  description: 'E-commerce focused with payments and directory',
  defaultRoute: 'marketplace',
  appModules: {
    home: { enabled: true, requiresFeature: 'home' },
    marketplace: { 
      enabled: true, 
      requiresFeature: 'payments.marketplace',
      checkIfLive: true 
    },
    directory: { enabled: true },
    payments: { 
      enabled: true, 
      requiresFeature: 'payments.donations',
      checkIfLive: true
    }
  },
  adminModules: {
    users: { enabled: true },
    payments: { enabled: true },
    settings: { enabled: true },
    design: { enabled: true },
    analytics: { enabled: true },
    onboarding: { enabled: true }
  }
}; 